// eslint-disable-next-line import/prefer-default-export
export const MY_PRODUCTS_URL_BY_SITE_TYPE = {
  b2c: `${window.vProductionUrl}/home/product-cart`,
  b2b: `${window.vProductionUrl}/product-cart`
};

export const SLASH = '/';

export const PRODUCT_RANGE_SEGMENT = '/product-range/';
